/* Bikesupermarket — reveal on scroll (IntersectionObserver), stagger per sezione.
   Nessuna dipendenza. Compatibile con il theme editor di Shopify. */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var root = document.documentElement;
  root.classList.add('bsm-motion');

  var ITEM_SELECTOR = '.text-block, .button, .button-custom, .button-primary, .button-secondary, .resource-list__item, .email-signup, form.email-signup';
  var STAGGER = 90;   // ms fra un elemento e il successivo
  var MAX_DELAY = 720; // ms

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      el.classList.add('is-in');
      io.unobserve(el);
      var delay = parseInt(el.style.getPropertyValue('--bsm-delay') || '0', 10);
      setTimeout(function () { el.classList.add('is-done'); }, delay + 1100);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

  function isNestedCard(el) {
    return !el.classList.contains('resource-list__item') && el.closest('.resource-list__item');
  }

  function prepareSection(section) {
    var items = section.querySelectorAll(ITEM_SELECTOR);
    var i = 0;
    var isHero = !!section.querySelector('.hero');
    Array.prototype.forEach.call(items, function (el) {
      if (el.hasAttribute('data-bsm-reveal')) return;
      if (isNestedCard(el)) return;
      // un text-block dentro un altro text-block: anima solo l'esterno
      if (el.classList.contains('text-block') && el.parentElement && el.parentElement.closest('.text-block')) return;
      el.setAttribute('data-bsm-reveal', '');
      var delay = Math.min(i * STAGGER, MAX_DELAY) + (isHero ? 250 : 0);
      el.style.setProperty('--bsm-delay', delay + 'ms');
      i++;
      io.observe(el);
    });
  }

  function init(scope) {
    scope = scope || document;
    var sections = scope.querySelectorAll('#MainContent > .shopify-section, footer .shopify-section');
    if (!sections.length && scope !== document && scope.classList && scope.classList.contains('shopify-section')) {
      sections = [scope];
    }
    Array.prototype.forEach.call(sections, prepareSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme editor: quando una sezione viene ricaricata o riordinata
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:reorder', function () { init(); });
  document.addEventListener('shopify:section:select', function (e) {
    // mostra subito gli elementi della sezione selezionata nell'editor
    Array.prototype.forEach.call(e.target.querySelectorAll('[data-bsm-reveal]'), function (el) {
      el.classList.add('is-in', 'is-done');
    });
  });

  // Sicurezza: se per qualsiasi motivo qualcosa resta nascosto, lo mostriamo dopo 4s
  setTimeout(function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-bsm-reveal]:not(.is-in)'), function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-in', 'is-done');
    });
  }, 4000);
})();

/* Home a schermate (stile armani.com): una rotellata = una sezione, la successiva
   sale e copre la precedente (sticky in CSS). Solo template index, desktop (>=990px),
   fuori dall'editor, non con prefers-reduced-motion. */
(function () {
  var main = document.getElementById('MainContent') || document.querySelector('main[data-template]');
  if (!main || main.getAttribute('data-template') !== 'index') return;
  if (document.documentElement.classList.contains('shopify-design-mode')) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var root = document.documentElement;
  root.classList.add('bsm-snap');

  function headerH() {
    var v = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-group-height'));
    return isNaN(v) ? 100 : v;
  }
  function measure() {
    var trust = document.querySelector('#MainContent > .shopify-section[id$="__trust_bar"]');
    if (trust) root.style.setProperty('--bsm-trust-h', trust.offsetHeight + 'px');
  }
  measure();
  window.addEventListener('load', measure);
  window.addEventListener('resize', measure);

  // Horizon su desktop scorre dentro .page-wrapper, non sulla finestra
  function scroller() {
    var pw = document.querySelector('.page-wrapper');
    if (pw && pw.scrollHeight > pw.clientHeight + 10 && /(auto|scroll)/.test(getComputedStyle(pw).overflowY)) return pw;
    return null; // finestra
  }
  function getTop(sc) { return sc ? sc.scrollTop : (window.scrollY || document.documentElement.scrollTop); }
  function viewH(sc) { return sc ? sc.clientHeight : window.innerHeight; }
  function maxTop(sc) { return sc ? sc.scrollHeight - sc.clientHeight : document.documentElement.scrollHeight - window.innerHeight; }
  function goTo(sc, y) {
    y = Math.max(0, Math.min(y, maxTop(sc)));
    if (sc) sc.scrollTo({ top: y, behavior: 'smooth' }); else window.scrollTo({ top: y, behavior: 'smooth' });
  }
  // posizioni delle "carte": ogni sezione tranne la griglia categorie (viaggia con la barra fiducia) + footer
  function targets(sc) {
    var h = headerH();
    var base = sc ? sc.getBoundingClientRect().top : 0;
    var top = getTop(sc);
    var list = [];
    var vh = viewH(sc);
    var mainTop = main.getBoundingClientRect().top - base + top; // inizio di #MainContent nel contenuto scorrevole
    var y = 0; // posizione nel flusso (lo sticky sposta i rect, quindi sommo le altezze)
    var cards = [];
    Array.prototype.forEach.call(main.children, function (s) {
      if (s.classList.contains('shopify-section')) {
        if (/__categorie$/.test(s.id) && cards.length) cards[cards.length - 1].bottom = mainTop + y + s.offsetHeight;
        else cards.push({ top: mainTop + y - h, bottom: mainTop + y + s.offsetHeight });
      }
      y += s.offsetHeight;
    });
    cards.forEach(function (c) {
      list.push(c.top);
      // carta piu' alta dello schermo: una fermata intermedia per vederne il fondo
      if (c.bottom - c.top > vh + 40) list.push(c.bottom - vh);
    });
    list.push(maxTop(sc)); // footer: fondo pagina
    return list.map(function (v) { return Math.max(0, Math.min(v, maxTop(sc))); });
  }
  var locked = false, acc = 0, accTimer = null;
  function onWheel(e) {
    if (window.innerWidth < 990) return;
    if (e.ctrlKey) return; // zoom
    // non intercettare dentro drawer, dialog o aree che scorrono da sole
    var t = e.target;
    if (t && t.closest && t.closest('dialog, [role="dialog"], .predictive-search, .cart-drawer, .menu-drawer, select, textarea')) return;
    var sc = scroller();
    if (sc && !sc.contains(t)) return;
    e.preventDefault();
    if (locked) return;
    acc += e.deltaY;
    clearTimeout(accTimer);
    accTimer = setTimeout(function () { acc = 0; }, 160);
    if (Math.abs(acc) < 24) return;
    var dir = acc > 0 ? 1 : -1;
    acc = 0;
    var list = targets(sc);
    var cur = getTop(sc);
    var next = null;
    if (dir > 0) {
      for (var i = 0; i < list.length; i++) { if (list[i] > cur + 8) { next = list[i]; break; } }
    } else {
      for (var j = list.length - 1; j >= 0; j--) { if (list[j] < cur - 8) { next = list[j]; break; } }
    }
    if (next === null) return;
    locked = true;
    goTo(sc, next);
    setTimeout(function () { locked = false; acc = 0; }, 900);
  }
  window.addEventListener('wheel', onWheel, { passive: false });
})();

/* Pagina contatti: precompila il messaggio quando si arriva da "Contattaci per un preventivo" */
(function () {
  var q = new URLSearchParams(window.location.search);
  var prodotto = q.get('prodotto');
  if (!prodotto) return;
  function fill() {
    var body = document.querySelector('textarea[name="contact[body]"], textarea[name*="body"], textarea');
    if (!body || body.value) return;
    var sku = q.get('sku');
    body.value = 'Buongiorno, vorrei ricevere un preventivo personalizzato per:\n' + prodotto + (sku ? ' (cod. ' + sku + ')' : '') + '\n\nGrazie.';
    body.dispatchEvent(new Event('input', { bubbles: true }));
    var subj = document.querySelector('input[name="contact[subject]"]');
    if (subj && !subj.value) subj.value = 'Richiesta preventivo: ' + prodotto;
    body.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fill); else fill();
})();

/* Scheda prodotto: al cambio variante il tema aggiorna solo il bottone carrello;
   qui sostituiamo il blocco bottoni quando cambia lo stato "preventivo" (giacenza 0). */
(function () {
  function onSelect(e) {
    if (!e.promise || typeof e.promise.then !== 'function') return;
    e.promise.then(function (res) {
      var html = res && res.detail && res.detail.html;
      if (!html || !html.querySelector) return;
      setTimeout(function () {
        var forms = document.querySelectorAll('product-form-component');
        Array.prototype.forEach.call(forms, function (form) {
          if (form.closest('quick-add-component')) return;
          var cur = form.querySelector('.product-form-buttons');
          var sid = form.getAttribute('data-section-id');
          var fresh = null;
          if (sid) {
            var sec = html.querySelector('#shopify-section-' + sid) || html;
            var f = sec.querySelector('product-form-component[data-section-id="' + sid + '"]') || sec.querySelector('product-form-component');
            fresh = f && f.querySelector('.product-form-buttons');
          }
          if (!cur || !fresh) return;
          var curQ = cur.querySelector('.bsm-quote'), newQ = fresh.querySelector('.bsm-quote');
          // cambia lo stato (carrello <-> preventivo) oppure cambia la variante su preventivo (link da aggiornare)
          if (!!curQ !== !!newQ || (curQ && newQ && curQ.innerHTML !== newQ.innerHTML)) cur.replaceWith(fresh.cloneNode(true));
        });
      }, 50);
    }).catch(function () {});
  }
  document.addEventListener('shopify:product:select', onSelect, true);
  document.addEventListener('product:select', onSelect, true);
})();
